module.exports = __webpack_public_path__ + "img/thumbnail_ManedWolf_m_normal.6e8bc7f6.png";